import React from "react";
import { Route, Switch } from "react-router-dom";
import Login from "../pages/auth/login/Login";
import Dashboard from "../pages/Dashboard/Dashboard";
import ViewEvent from "../pages/events/viewEvent/ViewEvent";
import EventFeatures from "../pages/events/createEvent/EventFeatures";
import Event from "../pages/events/Event";
import EventInfo from "../pages/events/createEvent/EventInfo";
import EventSummary from "../pages/events/createEvent/EventSummary";
import AppExperience from "../pages/events/createEvent/createEventChild/AppExperience";
import TableLive from "../pages/events/liveEvent/TableLive";
import TablePast from "../pages/events/pastEvent/TablePast";
import TableUpcoming from "../pages/events/upcomingEvent/TableUpcoming";
import Email from "../pages/events/createEvent/createEventChild/Email";
import SocialMedia from "../pages/events/createEvent/createEventChild/SocialMedia";
import EventType from "../pages/events/createEvent/EventType"
import PaymentPage from "../pages/events/createEvent/PaymentPage"
import PaymentSuccesful from "../pages/events/createEvent/PaymentSuccessful"
import { ProtectedRoute } from "./ProtectedRoute";
import { PublicRoute } from "./PublicRoute";
import EmailVerify from "../pages/auth/emailVerify/EmailVerify";
import EventOption from "../pages/events/createEvent/EventOption";
import RegisterUser from "../pages/auth/register/RegisterUser";
import TextSms from "../pages/events/createEvent/createEventChild/TextSms";
import DigitalSetting from "../pages/events/createEvent/createEventChild/DigitalSetting";
import Filter from "../pages/events/createEvent/createEventChild/Filter";
import MicroSite from "../pages/events/createEvent/createEventChild/MicroSite";
import DataCapture from '../pages/data-capture/DataCapture'
import DataCaptureView from '../pages/data-capture/View'
import PaymentCapture from '../pages/data-capture/data-capture-payment/PaymentCapture'
import PaymentSuccessfulPage from '../pages/data-capture/PaymentSuccessfulPage'
import EventOptionEdit from "../pages/eventEdit/EventOptionEdit";
import EventInfoEdit from "../pages/eventEdit/EventInfoEdit";
import EmailEdit from "../pages/eventEdit/EmailEdit";
import SocialMediaEdit from "../pages/eventEdit/SocialMediaEdit";
import TextSmsEdit from "../pages/eventEdit/TextSmsEdit";
import MicroSiteEdit from "../pages/eventEdit/MicroSiteEdit";
import Analytic from "../pages/events/EventAnalytic/Analytic";
import View from '../pages/events/ViewPhoto/View'
import FullScreenView from '../pages/events/ViewPhoto/FullScreenView'
import EventFrame from "../pages/events/createEvent/createEventChild/EventFrame";
import EventBoomerangFrame from "../pages/events/createEvent/createEventChild/EventBoomerangFrame";
import EventVideoFrame from "../pages/events/createEvent/createEventChild/EventVideoFrame";
import ForgotPassword from "../pages/auth/forgot/ForgotPassword";
import ResetPassword from "../pages/auth/forgot/ResetPassword";
import ResendEmail from "../pages/auth/emailVerify/ResendEmail";
import SocialGallery from "../pages/Social Gallery/SocialGallery";
import Error from "../Error/Error";
import DigitalProp from "../pages/eventEdit/DigitalProp";
import Frame from "../pages/eventEdit/Frame";
import PasswordChange from "../pages/auth/passwordChange/PasswordChange";
import Filters from "../pages/eventEdit/Filters";
import MicrositeDefault from "../pages/PublicPage/Microsite/MicrositeDefault";
import MicrositeDefaultView from "../pages/PublicPage/Microsite/MicrositeDefault/view";
import MicroSiteDefaultPassword from "../pages/PublicPage/Microsite/MicrositeDefault/Password";
import MicrositeOne from "../pages/PublicPage/Microsite/MicrositeOne";
import MicrositeOneView from "../pages/PublicPage/Microsite/MicrositeOne/view";
import MicrositeOnePassword from "../pages/PublicPage/Microsite/MicrositeOne/Password";
import MicrositeTwo from "../pages/PublicPage/Microsite/MicrositeTwo";
import MicrositeTwoView from "../pages/PublicPage/Microsite/MicrositeTwo/View";
import EventFeaturesEdit from "../pages/eventEdit/EventFeaturesEdit";
import InternalErrorPage from "../Error/InternalErrorPage";
import UnPaidRoute from "./UnPaidRoute";
import WaterMark from "../pages/events/createEvent/createEventChild/WaterMark";
import WaterMarkEdit from "../pages/eventEdit/WaterMarkEdit";
import MemberSettings from "../pages/Settings/MemberSettings";
import EditEmailTemplate from "../pages/events/EditTemplate/EditEmailTemplate";
import EditSocialShare from "../pages/events/EditTemplate/EditSocialShare";
import Gif from "../pages/events/createEvent/createEventChild/Gif";
import GifEdit from "../pages/eventEdit/GifEdit";
import BrustGif from "../pages/events/createEvent/createEventChild/BrustGif";
import BrustGifEdit from "../pages/eventEdit/BrustGifEdit";
import IncentiveOffer from "../pages/events/createEvent/createEventChild/IncentiveOffer";
import FormBuilderNew from "../pages/FormBuilder/FormBuilderNew";
import EventFormBuilder from "../pages/events/createEvent/createEventChild/EventFormBuilder";
import EventFormBuilderEdit from "../pages/eventEdit/EventFormBuilderEdit";
import IncentiveOfferEdit from "../pages/eventEdit/IncentiveOfferEdit";
import SlideShow from "../pages/events/Slideshow";
import EventDevice from "../pages/events/createEvent/EventDevice";
import Avail from "../pages/PublicPage/offer/avail";
import Profile from "../pages/auth/profile";
import SmsBilling from '../pages/SmsBilling'
import ConversationView from "../pages/SmsBilling/ConversationView";
import AutomationFlows from "../pages/SmsBilling/AutomationFlows";
import AutomationTemplates from "../pages/SmsBilling/AutomationTemplates";
import AutomationFlowPlaceholder from "../pages/SmsBilling/AutomationTemplates/AutomationFlowPlaceholder";
import Notifications from "../pages/SmsBilling/Notifications";
import AnalyticsBilling from "../pages/SmsBilling/AnalyticsBilling";
import AutomationAnalytics from "../pages/SmsBilling/AutomationAnalytics";
import BoomerangFrame from "../pages/eventEdit/BoomerangFrame";
import VideoFrame from "../pages/eventEdit/VideoFrame";
import { isTwoWaySmsEnabled } from "../pages/SmsBilling/smsAccess";
import RoiDashboard from "../pages/RoiDashboard";
import SocialGallerySettings from "../pages/SocialGalleryV2/Settings";
import SocialGalleryPublicMedia from "../pages/SocialGalleryV2/PublicMedia";
import SocialGalleryRecipientMedia from "../pages/SocialGalleryV2/RecipientMedia";
import SocialGalleryLeads from '../pages/SocialGalleryV2/Leads';
import SocialGalleryLeadDetail from '../pages/SocialGalleryV2/LeadDetail';
import SocialGalleryReports from '../pages/SocialGalleryV2/Reports';
import { GalleryAccessProvider } from '../pages/SocialGalleryV2/GalleryAccess';
import SocialGalleryRoute from './SocialGalleryRoute';
const AllRoutes = () => {

  return (
    <>
      <GalleryAccessProvider><Switch>
        <Route exact path="/social/gallery/v2/share/:token" component={SocialGalleryRecipientMedia} />
        <Route exact path="/social/gallery/v2/view/:id" component={SocialGalleryPublicMedia} />
        <SocialGalleryRoute exact path="/social-gallery/reports" component={SocialGalleryReports} />
        <SocialGalleryRoute exact path="/social-gallery/leads" component={SocialGalleryLeads} />
        <SocialGalleryRoute exact path="/social-gallery/leads/:id" component={SocialGalleryLeadDetail} />
        <SocialGalleryRoute exact path="/social-gallery/settings" component={SocialGallerySettings} />
        <PublicRoute exact path="/" component={Login} />
        <PublicRoute exact path="/register" component={RegisterUser} />
        <PublicRoute exact path="/verify-email/:code" component={EmailVerify} />
        <PublicRoute exact path="/resend/email" component={ResendEmail} />
        <PublicRoute exact path="/forgot" component={ForgotPassword} />
        <PublicRoute exact path="/reset/:token" component={ResetPassword} />


        {/* Microsite template view */}
        {/* <Route exact path="/gallery-share/:id" component={MicrositeDefault} />
        */}


        <Route exact path="/social/gallery/:id" component={MicrositeOne} />
        <Route exact path="/social/gallery/view/:id" component={MicrositeOneView} />
        <Route exact path="/social/gallery/password/:id" component={MicrositeOnePassword} />
        <Route exact path="/social/slide-show/:id" component={SlideShow} />

        <ProtectedRoute exact path="/gallery/share/two/:id" component={MicrositeTwo} />
        <ProtectedRoute exact path="/gallery/share/view/two/:id" component={MicrositeTwoView} />

        <ProtectedRoute exact path="/gallery/share/three/:id" component={MicrositeDefault} />
        <ProtectedRoute exact path="/gallery/share/view/three/:id" component={MicrositeDefaultView} />

        <ProtectedRoute exact path="/gallery/share/password" component={MicroSiteDefaultPassword} />

        <ProtectedRoute exact path="/change/password" component={PasswordChange} />

        <ProtectedRoute exact path="/data-capture/payment/success" component={PaymentSuccessfulPage} />
        <ProtectedRoute exact path="/data-capture" component={DataCapture} />
        <ProtectedRoute exact path="/data-capture-view/:id" component={DataCaptureView} />
        <ProtectedRoute exact path="/data-capture/payment" component={PaymentCapture} />
        <ProtectedRoute exact path="/conversions" component={SmsBilling} hasAccess={isTwoWaySmsEnabled} />
        <ProtectedRoute exact path="/conversions/conversations" component={ConversationView} hasAccess={isTwoWaySmsEnabled} />
        <ProtectedRoute exact path="/conversions/notifications" component={Notifications} hasAccess={isTwoWaySmsEnabled} />
        <ProtectedRoute exact path="/conversions/analytics-billing" component={AnalyticsBilling} hasAccess={isTwoWaySmsEnabled} />
        <ProtectedRoute exact path="/conversions/billing" component={AnalyticsBilling} hasAccess={isTwoWaySmsEnabled} />
        <ProtectedRoute exact path="/conversions/analytics" component={AutomationAnalytics} hasAccess={isTwoWaySmsEnabled} />
        <ProtectedRoute exact path="/conversions/view/:eventId" component={ConversationView} hasAccess={isTwoWaySmsEnabled} />
        <ProtectedRoute exact path="/conversions/sms-automation-templates" component={AutomationTemplates} hasAccess={isTwoWaySmsEnabled} />
        <ProtectedRoute exact path="/conversions/automation-flows" component={AutomationFlows} hasAccess={isTwoWaySmsEnabled} />
        <ProtectedRoute exact path="/conversions/automation-flows/:flowId" component={AutomationFlowPlaceholder} hasAccess={isTwoWaySmsEnabled} />
        <ProtectedRoute exact path="/roi-reports" component={RoiDashboard} hasAccess={isTwoWaySmsEnabled} />

        <ProtectedRoute exact path="/event" component={Event} />
        <ProtectedRoute exact path="/event/create" component={EventInfo} />
        <ProtectedRoute exact path="/event/info/edit/:id" component={EventInfoEdit} />
        <ProtectedRoute exact path="/event/feature" component={EventFeatures} />
        <ProtectedRoute exact path="/event/feature/edit/:id" component={EventFeaturesEdit} />

        <ProtectedRoute exact path="/event/options" component={EventOption} />
        <ProtectedRoute exact path="/event/options/edit/:id" component={EventOptionEdit} />
        <ProtectedRoute exact path="/event/social" component={SocialMedia} />
        <ProtectedRoute exact path="/event/social/edit/:id" component={SocialMediaEdit} />
        <ProtectedRoute exact path="/event/gif" component={Gif} />
        <ProtectedRoute exact path="/event/gif/edit/:id" component={GifEdit} />
        <ProtectedRoute exact path="/event/brust-gif" component={BrustGif} />
        <ProtectedRoute exact path="/event/brust-gif/edit/:id" component={BrustGifEdit} />
        <ProtectedRoute exact path="/event/email" component={Email} />
        <ProtectedRoute exact path="/event/email/edit/:id" component={EmailEdit} />
        <ProtectedRoute exact path="/event/sms" component={TextSms} />
        <ProtectedRoute exact path="/event/sms/edit/:id" component={TextSmsEdit} />
        <ProtectedRoute exact path="/event/digital-prop" component={DigitalSetting} />
        <ProtectedRoute exact path="/event/digital-prop/edit/:id" component={DigitalProp} />
        <ProtectedRoute exact path="/event/custom-branding" component={WaterMark} />
        <ProtectedRoute exact path="/event/custom-branding/edit/:id" component={WaterMarkEdit} />
        <ProtectedRoute exact path="/event/microsite" component={MicroSite} />
        <ProtectedRoute exact path="/event/microsite/edit/:id" component={MicroSiteEdit} />
        <ProtectedRoute exact path="/event/frame" component={EventFrame} />
        <ProtectedRoute exact path="/event/frame/edit/:id" component={Frame} />
        <ProtectedRoute exact path="/event/video-frame" component={EventVideoFrame} />
        <ProtectedRoute exact path="/event/video-frame/edit/:id" component={VideoFrame} />
        <ProtectedRoute exact path="/event/boomerang-frame" component={EventBoomerangFrame} />
        <ProtectedRoute exact path="/event/boomerang-frame/edit/:id" component={BoomerangFrame} />
        <ProtectedRoute exact path="/event/incentive-offer" component={IncentiveOffer} />
        <ProtectedRoute exact path="/event/incentive-offer/edit/:id" component={IncentiveOfferEdit} />
        <ProtectedRoute exact path="/event/form-builder" component={EventFormBuilder} />
        <ProtectedRoute exact path="/event/form-builder/edit/:id" component={EventFormBuilderEdit} />

        <ProtectedRoute exact path="/event/filter" component={Filter} />
        <ProtectedRoute exact path="/event/filter/edit/:id" component={Filters} />






        
        <ProtectedRoute exact path="/event/branding" component={AppExperience} />
 



        <ProtectedRoute exact path="/dashboard" component={Dashboard} />
        <ProtectedRoute exact path="/live-event" component={TableLive} />
        <ProtectedRoute exact path="/upcoming-event" component={TableUpcoming} />
        <ProtectedRoute exact path="/past-event" component={TablePast} />

        <ProtectedRoute exact path="/event-analytic/:id" component={Analytic} />
        <ProtectedRoute exact path="/event-photos/:id" component={View} />
        <ProtectedRoute exact path="/event-photos-fullscreen" component={FullScreenView} />
        {/* social gallery template */}
        <ProtectedRoute exact path="/social-template" component={SocialGallery} />

        <UnPaidRoute exact path="/event/type" component={EventType} />
        <UnPaidRoute exact path="/event/payment" component={PaymentPage} />

        <ProtectedRoute exact path="/event/payment-success" component={PaymentSuccesful} />

        <ProtectedRoute exact path="/event/summary" component={EventSummary} />

        <ProtectedRoute exact path="/event/device" component={EventDevice} />

        <ProtectedRoute exact path="/show/event/:id" component={ViewEvent} />

        <ProtectedRoute exact path="/member-settings" component={MemberSettings} />

        <ProtectedRoute exact path="/edit-email-template/:id" component={EditEmailTemplate} />
        <ProtectedRoute exact path="/edit-email-template/:id/:email_id" component={EditEmailTemplate} />

        <ProtectedRoute exact path="/edit-socail-template/:id" component={EditSocialShare} />

        <ProtectedRoute exact path="/edit-socail-template/:id/:social_id" component={EditSocialShare} />
        <ProtectedRoute exact path="/form-builder" component={FormBuilderNew} />


        <ProtectedRoute exact path="/profile" component={Profile} />
        
        <Route exact path="/offer/avail/:eventId/:uuid/:voucherNo" component={Avail} />

        <Route exact path="/error" component={InternalErrorPage} />

        <ProtectedRoute component={Error} />
      </Switch></GalleryAccessProvider>
    </>
  );
};
export default AllRoutes;
